import { mapGetters } from 'vuex';
import staticData from "@/mixins/api_data/static-data-mixin";

const defaultReturnFunction = (response) => { return response };
const defaultGetRegistryData = (response) => response?.data?.data?.registryDtos;

export default function (name, keylabel, path, getData = defaultGetRegistryData, converted = true, returnFunction = defaultReturnFunction) {
  return {
    mixins: [
      staticData('registries', path, getData, undefined, true)
    ],
    computed:{
      ...mapGetters('registries', ['getRegistry']),
      [name]: {
        get(){
          const _registry = getData(this.getRegistry(path));
          
          if (converted) {
              let index = _registry?.findIndex(registry => registry.keyLabel === keylabel);
              if (index >= 0) {
                switch(_registry[index].type) {
                  case "Boolean": return returnFunction(_registry[index].valueData==='true');
                  case "String": return returnFunction(_registry[index].valueData.toString());
                  default: return returnFunction(_registry[index].valueData);
                }
              }
            return null;
          }

          let index = _registry.findIndex(registry => registry.keyLabel === keylabel);
          if (index >= 0) 
            return returnFunction(_registry[index].valueData);

          return null;
        },
      }
    }
  }
}
